export const formatObjectToQueryString = obj => {
  if (obj instanceof Object) {
    return Object.keys(obj)
      .map(i => {
        var value = obj[i]
        if (Array.isArray(value)) {
          return value
            .map(v => {
              return i + '=' + value
            })
            .join('&')
        } else {
          return i + '=' + value
        }
      })
      .join('&')
  } else {
    console.log('Error queryStringFormat: param is not object!')
  }
}

export const capitalize = string => {
  if (string) {
    const match = string.match(/(?!<.?)(\w)(?!.?>)/)
    let chars = string.split('')

    chars[match.index] = chars[match.index].toUpperCase()

    return chars.join('')
  }
  return string
}

export const capitalizeEachWord = string => {
  if (string) {
    const arr = string.split(' ')

    //loop through each element of the array and capitalize the first letter.

    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1)
    }

    //Join all the elements of the array back into a string
    //using a blankspace as a separator
    const str2 = arr.join(' ')
    return str2
  }
  return ''
}

export const removeAccents = string => {
  return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

export const contains = (string1, string2) => {
  if (string1 === null || string2 === null) return false

  const s1 = removeAccents(string1.toLowerCase())
  const s2 = removeAccents(string2.toLowerCase())

  return s1.indexOf(s2) > -1
}

export const createRelevanceIndex = (value, term) => {
  if (!contains(value, term)) return false

  const valueSplit = value.split(' ')
  if (valueSplit.length === 1) return 1

  let foundIndex = valueSplit.findIndex(item => contains(item, term))

  return foundIndex === -1 ? false : foundIndex
}

export const toDate = dateStr => {
  const [day, month, year] = dateStr.split('/')
  return new Date(year, month - 1, day)
}

export const twoDigit = num => {
  if (num.toString().length === 2) return num.toString()

  return `0${num}`
}

export const formatarDataMysql = data => {
  return new Date(`${data} 00:00`).toLocaleDateString()
}

export const formatarMoeda = val => {
  let value = val
  if (typeof val === 'string') {
    value = Number(val)
  }
  return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
}

// CREDO, OLHA A GAMBIARRA
export const desformatarMoeda = val => {
  return Number(val.replace(/[R$ .]/g, '').replace(',', '.'))
}

export const mesesAbr = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez'
]

export const mesesExt = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro'
]



// WEBPACK FOOTER //
// ./src/utils/strings.js